import React from 'react';
import {
  FeatureFlagEnum,
  ModuleEnum,
  PermissionOperationEnum,
} from 'src/api/ProactApiClient';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';
import type {
  ItemDefinitionViewType} from 'src/app/item-tracker/ItemDefinitionForm';
import {
  ItemDefinitionForm
} from 'src/app/item-tracker/ItemDefinitionForm';
import {itemDefinitionDocumentTitle} from 'src/app/item-tracker/itemDefinitionHelpers';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';
import type {ViewModeType} from 'src/shared/services/RouterService/IRouteService';
import {ItemDefinitionRouteService} from 'src/shared/services/RouterService/ItemDefinitionRouteService';

import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';

const ItemDefinitionCreatePage: React.FC = () => {
  useSetDocumentTitle(`${itemDefinitionDocumentTitle} - Create`);

  const mode: ViewModeType = 'create';
  const router = new ItemDefinitionRouteService(false, mode, {
    view: 'content' as ItemDefinitionViewType,
  });

  return (
    <ContentWrapper featureFlag={FeatureFlagEnum.ItemTracker}>
      <ItemDefinitionForm
        id={undefined}
        mode="create"
        view="content"
        router={router}
      />
    </ContentWrapper>
  );
};

export default ItemDefinitionCreatePage;

routeRegistry.registerPageRoute({
  backNavigation: 'form',
  path: PathUtility.ItemDefinitionCreate(),
  element: <ItemDefinitionCreatePage />,
  isPrivate: true,
  module: ModuleEnum.ItemTrackerDefinitions,
  operation: PermissionOperationEnum.Create,
});
